import React from 'react';
import {Route, Routes} from 'react-router-dom';
import ComsLanding from './ComsLanding';
import ComsHome from './ComsHome';
import BlockDashboard from './BlockDashboard';
import LabourTrackerHome from './LabourTrackerHome';
import SheqHome from './SheqHome';
import ProTrackHome from './ProTrackHome';

const ComsRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<ComsLanding />} />
      <Route path="daily-site-report" element={<ComsHome />} />
      <Route path="daily-site-report/blocks/:blockId/*" element={<BlockDashboard />} />
      <Route path="labour-tracker" element={<LabourTrackerHome />} />
      <Route path="sheq" element={<SheqHome />} />
      <Route path="protrack" element={<ProTrackHome />} />
    </Routes>
  );
};

export default ComsRoutes;
